
  .responsive3208187990__root .Input3620606023__root {
    --Inputresponsive3282537969-inner-border-color: #cfd1dc;
    box-shadow: inset 0 0 0 1px var(--Inputresponsive3282537969-inner-border-color);
  }

/* Size */
  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-5-small {
    height: 24px;
    padding: 4px 8px;
  }

  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-5-small .Input3620606023__input {
  font-size: 11px;
  line-height: 16px;
  }

  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-6-medium {
    height: 28px;
    padding: 6px 8px;
  }

  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-6-medium .Input3620606023__input {
  font-size: 12px;
  line-height: 16px;
  }

  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-5-large {
    height: 32px;
    padding: 6px 8px;
  }

  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-5-large .Input3620606023__input {
  font-size: 14px;
  line-height: 20px;
  }

/* Hover */
  .responsive3208187990__root .Input3620606023__root:hover:not(:focus):not(.Input3620606023--disabled) {
    background-color: #ffffff;
    --Inputresponsive3282537969-inner-border-color: #000624;
  }
  .responsive3208187990__root .Input3620606023__root:hover:not(:focus):not(.Input3620606023--disabled) .Input3620606023__input {
    background-color: #ffffff;
  }

/* Focus */
  .responsive3208187990__root .Input3620606023__root:focus-within {
    outline: none;
    --Inputresponsive3282537969-inner-border-color: #000624;
  }

/* Affix */
  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-5-large .Input3620606023__prefix {
    padding-right: 8px;
    color: #595d70;
  }

  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-6-medium .Input3620606023__prefix,
  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-5-small .Input3620606023__prefix {
    padding-right: 4px;
    color: #595d70;
  }

  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-5-large .Input3620606023__suffix {
    padding-left: 8px;
    color: #595d70;
  }

  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-6-medium .Input3620606023__suffix,
  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-5-small .Input3620606023__suffix {
    padding-left: 4px;
    color: #595d70;
  }

  .responsive3208187990__root .Input3620606023__root .Input3620606023__prefix(standard),
  .responsive3208187990__root .Input3620606023__root .Input3620606023__suffix(standard) {
    color: #595d70;
  }

  .responsive3208187990__root .Input3620606023__root .Input3620606023__prefixNode svg,
  .responsive3208187990__root .Input3620606023__root .Input3620606023__suffixNode svg {
    fill: #595d70;
  }

/* Status */
  .responsive3208187990__root .Input3620606023__root.Input3620606023---status-7-warning,
  .responsive3208187990__root .Input3620606023__root:hover:not(:focus).Input3620606023---status-7-warning {
    --Inputresponsive3282537969-inner-border-color: #faad4d;
  }

  .responsive3208187990__root .Input3620606023__root.Input3620606023---status-5-error,
  .responsive3208187990__root .Input3620606023__root:hover:not(:focus).Input3620606023---status-5-error {
    --Inputresponsive3282537969-inner-border-color: #ee4437;
  }

  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-5-large .Input3620606023__icon {
    margin: 0 0 0 8px;
  }

  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-6-medium .Input3620606023__icon,
  .responsive3208187990__root .Input3620606023__root.Input3620606023---size-5-small .Input3620606023__icon {
    margin: 0 0 0 4px;
  }

  /* Disabled */
  .responsive3208187990__root .Input3620606023__root.Input3620606023--disabled {
    background-color: #f3f3f3;
    --Inputresponsive3282537969-inner-border-color: #bebebe;
  }
  
  .responsive3208187990__root .Input3620606023__root.Input3620606023--disabled .Input3620606023__input {
    background-color: #f3f3f3;
  }

  .responsive3208187990__root .Input3620606023__root.Input3620606023--disabled .Input3620606023__icon {
    fill: #bebebe;
  }

  .responsive3208187990__root .Input3620606023__root.Input3620606023--disabled .Input3620606023__prefixNode svg,
  .responsive3208187990__root .Input3620606023__root.Input3620606023--disabled .Input3620606023__suffixNode svg {
    fill: #bebebe;
  }

/* st-namespace-reference="../../../../src/atoms/Input/Input.responsive.st.css" */